<template>
  <div style="position:relative;">
    <slide-navbar-component />
    <navbar-component />
    <banner-component
      bannerTitle='MENU'
      :bannerImage='bannerImage'
    />
    <digital-menu-layout />
    <order-form-layout />
    <footer-component />
  </div>
</template>

<script>
import SlideNavbarComponent from "@/components/SlideNavbar.vue";
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import BannerComponent from "@/components/Banner.vue";
import DigitalMenuLayout from "@/layouts/order/DigitalMenu.vue";
import OrderFormLayout from "@/layouts/order/OrderForm.vue";

export default {
  name: "OrderView",
  data() {
    return {
      //variables
      bannerImage: `url(${require("@/assets/images/order/banner.png")})`,
    };
  },

  components: {
    SlideNavbarComponent,
    NavbarComponent,
    BannerComponent,
    FooterComponent,
    DigitalMenuLayout,
    OrderFormLayout,
  },
};
</script>